import { superCall as _$su, className as _$cn, extend as _$ex, EMPTY_OBJ as _$em, noop as _$no, createElementVNode as _$ce, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { Button } from '../button';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$dropdown$get = this.dropdown.get(),
    showArrow = _this$dropdown$get.showArrow,
    confirm = _this$dropdown$get.confirm,
    className = _this$dropdown$get.className,
    theme = _this$dropdown$get.theme,
    hoverable = _this$dropdown$get.hoverable,
    trigger = _this$dropdown$get.trigger,
    value = _this$dropdown$get.value,
    cancelText = _this$dropdown$get.cancelText,
    okText = _this$dropdown$get.okText,
    size = _this$dropdown$get.size,
    always = _this$dropdown$get.always;
  var _this$get = this.get(),
    children = _this$get.children;
  var _this$arrow = this.arrow,
    arrowRef = _this$arrow.arrowRef,
    arrowType = _this$arrow.arrowType;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-tooltip-content"] = true, _classNameObj[k + "-hoverable"] = hoverable || trigger === 'click', _classNameObj[k + "-always"] = always, _classNameObj[k + "-" + theme] = true, _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj[$props.className] = $props.className, _classNameObj);
  return _$su.call($this, {
    'value': !!value && !this.isEmptyChildren,
    'transition': {
      name: k + "-fade",
      onEnter: this.onEnter,
      onAfterLeave: this.onAfterLeave,
      onLeaveCancelled: this.onAfterLeave
    },
    'className': _$cn(classNameObj)
  }, function ($blocks) {
    var _$blocks = {},
      __$blocks = _$ex({}, $blocks);
    return (_$blocks['children'] = function ($super) {
      var _$cn2;
      return [(_$blocks['body'] = function ($super) {
        return children;
      }, __$blocks['body'] = function ($super, data) {
        var block = $blocks['body'];
        var callBlock = function callBlock() {
          return _$blocks['body'].call($this, $super, data);
        };
        return block ? block.call($this, callBlock, data) : callBlock();
      }, __$blocks['body'](_$no)), confirm ? _$ce(2, 'div', (_$blocks['footer'] = function ($super) {
        return [_$cc(Button, {
          'ev-click': this.cancel,
          'size': 'small',
          'children': cancelText
        }), _$cc(Button, {
          'type': 'primary',
          'ev-click': this.ok,
          'size': 'small',
          'children': okText
        })];
      }, __$blocks['footer'] = function ($super, data) {
        var block = $blocks['footer'];
        var callBlock = function callBlock() {
          return _$blocks['footer'].call($this, $super, data);
        };
        return block ? block.call($this, callBlock, data) : callBlock();
      }, __$blocks['footer'](_$no)), 0, _$cn(k + "-tooltip-footer"), null, 'tooltip-footer') : undefined, showArrow ? _$ce(2, 'i', null, 1, _$cn((_$cn2 = {}, _$cn2[k + "-tooltip-arrow"] = true, _$cn2[k + "-" + arrowType.value] = arrowType.value, _$cn2)), null, 'tooltip-arrow', arrowRef) : undefined];
    }, __$blocks['children'] = function ($super, data) {
      var block = $blocks['children'];
      var callBlock = function callBlock() {
        return _$blocks['children'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), __$blocks;
  }.call($this, $blocks), $__proto__);
}
;